import { render, staticRenderFns } from "./LinkList.vue?vue&type=template&id=6f87b6cb&scoped=true&"
import script from "./LinkList.vue?vue&type=script&lang=js&"
export * from "./LinkList.vue?vue&type=script&lang=js&"
import style0 from "./LinkList.vue?vue&type=style&index=0&id=6f87b6cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f87b6cb",
  null
  
)

export default component.exports